import { Avatar, Button, Dropdown } from "antd";
import { api } from "../../../api";
import { Link as RotuerLink, useNavigate } from "react-router-dom";
import profilePlaceholder from "../../../assets/png/profile-placeholder.png";
import ProfileDetailModal from "../modal/ProfileDetailModal";
import { useCurrentUser } from "../../../api/hooks/auth";
import { SettingOutlined } from "@ant-design/icons";

function ProfileMenu() {
  const { data: userData } = useCurrentUser();

  const navigate = useNavigate();
  function handleLogout() {
    // remove authentication token from local storage
    localStorage.removeItem("authToken");

    // remove Authorization from api axios instance
    delete api.defaults.headers.common["Authorization"];

    navigate("/auth", { replace: true });
  }

  const items = [
    {
      label: <Button onClick={handleLogout}>Logout</Button>,
      key: "Logout",
    },
    // {
    //   key: "Settings",
    //   label: "Settings",
    //   icon: <SettingOutlined />,
    //   // extra: '⌘S',
    // },
  ];

  return (
    <>
      <Dropdown
        menu={{
          items,
        }}
        trigger={["click"]}
        // placement="bottomRight"
      >
        <Avatar
          // alt="Profile Avatar"
          // src={profilePlaceholder}
          className="cursor-pointer"
        >
          {userData?.name?.charAt(0)?.toUpperCase()}
        </Avatar>
      </Dropdown>
    </>
  );
}

export default ProfileMenu;
